module.exports = __webpack_public_path__ + "ecosystem.b8ab317f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/ecosystem.png
// module id = 356
// module chunks = 0